<template>
	<div v-if="loading" class="loader-overlay">
		<div class="loader-spinner">
			<div
				v-for="n in 12"
				:key="n"
				:style="{ animationDelay: `${-n * 0.083}s`, transform: `rotate(${n * 30}deg)` }"
			></div>
		</div>
	</div>

	<main v-if="!loading && game">
		<div id="game-info">
			<div class="game-content">
				<img class="thumb" :src="game.banner_sm_url" :alt="game.name" />
				<div class="info">
					<h2>{{ $t(game.name) }}</h2>
					<p>{{ $t(game.short_description) }}</p>
				</div>
			</div>

			<button class="play-button" @click="playGame()">
				<svg
					class="svg-inline--fa fa-play fa-w-14 fa-1x"
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="play"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 448 512"
				>
					<path
						fill="currentColor"
						d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
					></path>
				</svg>
				{{ $t('Play Now') }}
			</button>
		</div>

		<div class="detail_content_section">
			<div class="detail_content_title">{{ $t('Browse Other Games') }}</div>
			<section class="content_grid">
				<router-link
					v-for="relatedGame in relatedGames"
					:key="relatedGame._id"
					:to="{ name: 'GameDetails', params: { id: relatedGame._id } }"
				>
					<div class="game_card">
						<img
							class="card_img"
							:alt="relatedGame.name"
							decoding="async"
							height="250"
							loading="lazy"
							:src="relatedGame.banner_sm_url"
							width="250"
						/>
						<div class="card_title">{{ $t(relatedGame.name) }}</div>
					</div>
				</router-link>
			</section>
		</div>
	</main>
</template>

<script>
export default {
	props: {
		locals: Object,
	},
	data() {
		return {
			game: null,
			relatedGames: [],
			gamesData: [],
			loading: true,
		};
	},
	watch: {
		'$route.params.id': {
			immediate: true,
			handler(id) {
				if (!this.gamesData.length) return;
				this.setGameDetails(id);
			},
		},
	},
	async mounted() {
		try {
			const response = await fetch('/games.json');
			if (!response.ok) throw new Error('Failed to load games.json');
			this.gamesData = await response.json();
			console.log('Loaded games:', this.gamesData);
			const gameId = this.$route.params.id;
			this.setGameDetails(gameId);
		} catch (error) {
			console.error('Error loading game data:', error);
		} finally {
			this.loading = false;
		}
	},
	methods: {
		setGameDetails(id) {
			this.game = this.gamesData.find((g) => String(g._id) === String(id));
			if (this.game) {
				this.relatedGames = this.gamesData.filter((g) => g._id !== id).slice(0, 8);
			}
		},
		playGame() {
			if (this.locals.loggedIn && this.game?.url) {
				if (this.locals.subscriber.content_access) {
					// return (window.location.href = this.game.url);
					return window.open(this.game.url, '_blank');
				} else {
					return (window.location.href = '/expired');
				}
			}
			return (window.location.href = '/login');
		},
	},
};
</script>
